import { animate, state, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';

@Component({
  standalone: true,
  selector: 'app-question-block',
  templateUrl: './question-block.component.html',
  styleUrls: ['./question-block.component.css'],
  imports: [
    ButtonModule,
    DividerModule,
    CommonModule,
    FormsModule
  ],
  animations: [
    trigger('fadeInOut', [
      state('void', style({
        opacity: 0,
      })),
      state('*', style({
        opacity: 1
      })),
      transition('void <=> *', animate(200)),
    ]),
  ],
})
export class QuestionBlockComponent {
  // Inputs que deciden si se visualiza el boton para eliminar el componente
  @Input('order') order!: number
  @Input('first') first = false

  question = "Agregar pregunta"

  lod_question = ""

  state = 'void'

  ngOnInit() {
    this.state = '*'
  }

  getText(text: string, input: HTMLTextAreaElement) {
    text = text.replace(/(\r\n|\n|\r)/gm, '');
    if(text) {
      this.question = ""
      input.value = text
      input.style.height = '35px'
      input.style.height = `${input.scrollHeight}px`
    }
    else {
      this.question = "Agregar pregunta"
      input.style.height = `35px`
    }
  }

  deleteTrim(text: string, input: HTMLTextAreaElement) {
    text = text.trim()
    input.value = text
  }

  // Instancia del view container para generar los componentes
  @Output('delete') delete = new EventEmitter<boolean>()
  // Generamos el componente e instanciamos su observable para eliminarlo
  deleteView() {
    this.delete.emit(true)
  }


  /**
   * @description Manages the resize of the screen.
   */
  @ViewChild('input') input!: ElementRef<HTMLTextAreaElement>
  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.getText(this.input.nativeElement.value, this.input.nativeElement)
  }

}
